import {JSONMapped, jsonProperty} from "json-mapper-reflect";
import * as JSONMapper from "json-mapper";
import {MasterAircraftTailNumber} from "./master-aircraft-tail-number";
import {MasterAircraftInfo} from "./master-aircraft-info";
import {ModelSummary} from "./model-summary";
import {MasterAircraftSystemSummary} from "./master-aircraft-system-summary";
import {ConnectedCockpitRegistration} from "./connected-cockpit-registration";
import {MasterAircraftWakeupSettings} from "./master-aircraft-wakeup-settings";

export class MasterAircraftSummary extends JSONMapped() {
	@jsonProperty()
	uuid: string;

	@jsonProperty()
	serialNumber: string;

	@jsonProperty(JSONMapper.classByMethods(ConnectedCockpitRegistration))
	connectedCockpitRegistration: ConnectedCockpitRegistration;

	@jsonProperty(JSONMapper.classByMethods(MasterAircraftInfo))
	info: MasterAircraftInfo;

	@jsonProperty((JSONMapper.arrayOfClass(MasterAircraftSystemSummary)))
	systems: Array<MasterAircraftSystemSummary>;

	@jsonProperty(JSONMapper.classByMethods(MasterAircraftTailNumber))
	tailNumber: MasterAircraftTailNumber;

	@jsonProperty(JSONMapper.classByMethods(MasterAircraftWakeupSettings))
	wakeupSettings: MasterAircraftWakeupSettings;

	@jsonProperty(JSONMapper.classByMethods(ModelSummary))
	model: ModelSummary;

	constructor(data?: Partial<MasterAircraftSummary>) {
		super();
		Object.assign(this, data);
	}

	get makeModelYear() {
		return `${this.info.year} ${this.model.make.name} ${this.model.name}`;
	}
}
